<template>
  <div>
      <tplheader></tplheader>
      <tplLeftPanel></tplLeftPanel>
    <form>
      <div id="main-panel" class="main-panel">
        <div class="content-panel">
          <ul class="breadcrumb">
            <li>Kezdőőoldal</li>
            <li>Karbantartás</li>
            <li v-show="false"><a href="#" class="active">Karbantartás</a></li>
          </ul>
          <div class="page-title">
            <h1><i class="material-icons">chevron_right</i>Karbantartás</h1>
          </div>
          <div class="panel">
            <div class="panel-heading">
              <h4>Műveletek</h4>
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-xs-12">
                  <div style="display:flex; flex-wrap: wrap; margin: 0px -5px;">
                    <button style="margin: 5px 5px" v-on:click="batchInactivate" type="button" class="btn btn-primary with-icon"><i class="fa with-spinner" v-bind:class="inactButtonIcon()"></i>Inaktiválás indítása (Jogviszonnyal nem rendelkező hallgatók kártyáinak felfüggesztése)</button>
                    <button style="margin: 5px 5px" :disabled="hallgatoTagozatFrissitesProgress" v-on:click="hallgatoTagozatFrissites" type="button" class="btn btn-primary with-icon"><i class="fa with-spinner" v-bind:class="hallgatoTagozatFrissitesButtonIcon()"></i>Hallgató tagozat frissítés</button>
                    <button style="margin: 5px 5px" :disabled="hallgatoNeptunFrissitesProgress" v-on:click="hallgatoNeptunFrissites" type="button" class="btn btn-primary with-icon"><i class="fa with-spinner" v-bind:class="hallgatoNeptunFrissitesButtonIcon()"></i>Hallgató adatok frissítése Neptunból{{ hallgatoNeptunFrissitesButtonTitleExtra }}</button>
                  </div>
                </div>
                <div class="col-xs-12">
                  <div style="display:flex; flex-wrap: wrap; margin: 0px -5px;">
                    <button style="margin: 5px 5px" v-on:click="batchInactivateLogDownload" type="button" class="btn btn-primary with-icon"><i class="fa with-spinner" v-bind:class="logButtonIcon()"></i>Logfájlok letöltése</button>
                    <button :disabled="golyahet_excel_import_folyamatban" style="margin: 5px 5px" v-on:click="golyahetImport" type="button" class="btn btn-primary with-icon"><i class="fa with-spinner" :class="golyahet_excel_import_folyamatban ? 'fa-circle-o-notch fa-spin fa-fw' : 'fa-refresh'"></i>Gólyahét excel import ("A" oszlopban neptunkódok)</button>
                    <input @change="golyahetExcelFajlKivalasztva" style="display: none" ref="golyahet_excel_import_fajl" type="file" name="excel_file" accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"/>
                    <!--<button v-on:click="batchInactivateByList" type="button" class="btn btn-primary with-icon"><i class="fa with-spinner" v-bind:class="inactByListButtonIcon()"></i>Listás inaktiválás indítása (DEVELOPER!)</button>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel">
            <div class="panel-heading">
              <h4>Fotók letöltése</h4>
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-sm-2">
                  <inputbox datepicker="1" id="from_date" label="Időponttól" v-bind:errors="errors" name="from_date" v-model="fromDate"></inputbox>
                </div>
                <div class="col-sm-2">
                  <inputbox datepicker="1" id="to_date" label="Időpontig" v-bind:errors="errors" name="to_date" v-model="toDate"></inputbox>
                </div>
                <div class="col-sm-1">
                  <combobox id="quality" label="Minőség" name="quality" v-model="quality"></combobox>
                </div>
                <div class="col-sm-2">
                  <combobox id="type" label="Export alap" name="type" v-model="type"></combobox>
                </div>
                <div class="col-sm-5">
                  <button style="margin-top: 15px" :disabled="photoDownloading" v-on:click="downloadPhoto" type="button" class="btn btn-primary with-icon"><i class="fa with-spinner" v-bind:class="downloadPhotoBtnClass"></i>Letöltés</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import tplheader from './tpl_header.vue';
import tplLeftPanel from './tpl_leftpanel.vue';

export default {
  components: {
    tplheader,
    tplLeftPanel
  },
  data: function() {
    return {
      inactivating: false,
      logCreating: false,
      hallgatoTagozatFrissitesProgress: false,
      hallgatoNeptunFrissitesProgress: false,
      errors: [],
      photoDownloading: false,
      fromDate: moment(new Date()).subtract(1, 'year').format('YYYY-MM-DD'),
      toDate: moment(new Date()).format('YYYY-MM-DD'),
      hallgatoNeptunFrissitesButtonTitleExtra: '',
      golyahet_excel_import_folyamatban: false,
      quality: {
        items: [
          {
            value: 10,
            label: "10%"
          },
          {
            value: 20,
            label: "20%"
          },
          {
            value: 30,
            label: "30%"
          },
          {
            value: 40,
            label: "40%"
          },
          {
            value: 50,
            label: "50%"
          },
          {
            value: 60,
            label: "60%"
          },
          {
            value: 70,
            label: "70%"
          },
          {
            value: 80,
            label: "80%"
          },
          {
            value: 90,
            label: "90%"
          },
          {
            value: 100,
            label: "100%"
          }
        ],
        selected: 100
      },
      type: {
        items: [
          {
            value: 'neptun',
            label: "Neptun kód"
          },
          {
            value: 'orgware_id',
            label: "Törzsszám"
          }
        ],
        selected: "neptun"
      }
    }
  },
  mounted: function() {
    this.$root.ajax('maintenance', {
      success: function(response) {

      }
    });
  },
  computed: {
    downloadPhotoBtnClass: function() {
      return this.photoDownloading ? 'fa-circle-o-notch fa-spin fa-fw' : 'fa-download'
    }
  },
  methods: {
    hallgatoTagozatFrissites: function() {
      var _this = this;
      this.hallgatoTagozatFrissitesProgress = true;

      this.$root.ajax('maintenance/hallgatotagozatfrissites', {
        method: 'get',
        success: function(response) {
          _this.hallgatoTagozatFrissitesProgress = false;

          if (response.error != undefined) {
            alert(response.error);
          }
        }
      });
    },

    hallgatoNeptunFrissites: function() {
      var _this = this;

      this.hallgatoNeptunFrissitesProgress = true;
      this.hallgatoNeptunFrissitesButtonTitleExtra = '';

      var progress_filename = 'hallgato_neptun_frissites_p_' + new Date().getTime() + '.txt';
      var interval;

      this.$root.ajax('maintenance/hallgato_neptun_frissites', {
        method: 'post',
        data: {
          progress_filename: progress_filename
        },
        success: function(response) {
          _this.hallgatoNeptunFrissitesProgress = false;
          _this.hallgatoNeptunFrissitesButtonTitleExtra = '';
          clearInterval(interval);

          if (response.error != undefined) {
            clearInterval(interval);
            _this.hallgatoNeptunFrissitesButtonTitleExtra = '';
            alert(response.error);
          }
        }
      });

      interval = setInterval(() => {
        fetch('logs/'+progress_filename)
        .then((response) => response.text())
        .then((data) => {
          if (data != undefined && data != '') {
            _this.hallgatoNeptunFrissitesButtonTitleExtra = data;
          }
        });
      }, 1000);
    },

    downloadPhoto: function() {
      var _this = this;

      this.photoDownloading = true;

      this.$root.ajax('maintenance/downloadphotos', {
        method: 'post',
        data: {
          from_date: this.fromDate,
          to_date: this.toDate,
          quality: this.quality,
          type: this.type
        },
        success: function(response) {
          _this.photoDownloading = false;
          _this.errors = [];

          if (response.errors.length > 0) {
            _this.errors = response.errors;
          } else {
            window.open(response.zipfile);
          }
        }
      });
    },

    batchInactivate: function() {
      if(this.inactivating) {
        return;
      }
      var _this = this;

      this.inactivating = true;

      this.$root.ajax('batchinactivate', {
        success: function(response) {
          _this.inactivating = false;
          _this.errors = [];

          if (response.errors.length > 0) {
            _this.errors = response.errors;
          } else {
            if (response.swal_message != undefined) {
              swal(response.swal_title, response.swal_message, response.swal_type);
            }
          }
        }
      });
    },
    batchInactivateByList: function() {
      if(this.inactivatingbylist) {
        return;
      }
      var _this = this;

      this.inactivatingbylist = true;

      this.$root.ajax('batchinactivatebylist', {
        success: function(response) {
          _this.inactivatingbylist = false;
          _this.errors = [];

          if (response.errors.length > 0) {
            _this.errors = response.errors;
          } else {
            if (response.swal_message != undefined) {
              swal(response.swal_title, response.swal_message, response.swal_type);
            }
          }
        }
      });
    },
    inactButtonIcon: function() {
      return this.inactivating ? 'fa-circle-o-notch fa-spin fa-fw' : 'fa-thumbs-o-down'
    },
    inactByListButtonIcon: function() {
      return this.inactivatingbylist ? 'fa-circle-o-notch fa-spin fa-fw' : 'fa-thumbs-o-down'
    },
    logButtonIcon: function() {
      return this.logCreating ? 'fa-circle-o-notch fa-spin fa-fw' : 'fa-download'
    },
    hallgatoTagozatFrissitesButtonIcon: function() {
      return this.hallgatoTagozatFrissitesProgress ? 'fa-circle-o-notch fa-spin fa-fw' : 'fa-refresh'
    },
    hallgatoNeptunFrissitesButtonIcon: function() {
      return this.hallgatoNeptunFrissitesProgress ? 'fa-circle-o-notch fa-spin fa-fw' : 'fa-refresh'
    },
    batchInactivateLogDownload: function() {
      if(this.logCreating) {
        return;
      }
      var _this = this;

      this.logCreating = true;

      this.$root.ajax('batchinactivatelog', {
        success: function(response) {
          _this.logCreating = false;

          if (response.errors.length > 0) {
            _this.errors = response.errors;
          } else {
            if (response.swal_message != undefined) {
              swal(response.swal_title, response.swal_message, response.swal_type);
            } else {
              window.open('/logs/'+response.fileName);
            }
          }
        }
      });
    },
    golyahetImport() {
      this.$refs.golyahet_excel_import_fajl.click();
    },

    golyahetExcelFajlKivalasztva() {
      const _this = this;

      try {
        if (this.$refs.golyahet_excel_import_fajl.files[0] == undefined) {
          throw 'Kötelező fájl';
        }

        if (this.$refs.golyahet_excel_import_fajl.files[0].type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          throw 'Csak excel fájl importálható!';
        }

        this.golyahet_excel_import_folyamatban = true;

        var form_data = new FormData();
        form_data.append("file", this.$refs.golyahet_excel_import_fajl.files[0]);

        this.$root.ajax('maintenance/golyahet_import', {
          contentType: false,
          processData: false,
          data: form_data,
          method: 'POST',
          success: function(response) {
            _this.$refs.golyahet_excel_import_fajl.value = null;
            _this.golyahet_excel_import_folyamatban = false;

            if (response.error_msg != undefined) {
              swal('Hiba', response.error_msg, 'error');

            } else {
              swal('Siker', 'Importálás sikeresen megtörtént', 'success');
            }
          }
        });

      } catch(error) {
        swal('Hiba', error, 'error');
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// maintenance.vue?7130fef2